var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_5716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33343 18.1812C3.83558 18.3333 4.51382 18.3333 5.66675 18.3333H14.3334C15.4863 18.3333 16.1646 18.3333 16.6667 18.1812M3.33343 18.1812C3.22577 18.1485 3.12619 18.1089 3.03177 18.0608C2.56137 17.8211 2.17892 17.4387 1.93923 16.9683C1.66675 16.4335 1.66675 15.7334 1.66675 14.3333V5.66663C1.66675 4.26649 1.66675 3.56643 1.93923 3.03165C2.17892 2.56124 2.56137 2.17879 3.03177 1.93911C3.56655 1.66663 4.26662 1.66663 5.66675 1.66663H14.3334C15.7335 1.66663 16.4336 1.66663 16.9684 1.93911C17.4388 2.17879 17.8212 2.56124 18.0609 3.03165C18.3334 3.56643 18.3334 4.26649 18.3334 5.66663V14.3333C18.3334 15.7334 18.3334 16.4335 18.0609 16.9683C17.8212 17.4387 17.4388 17.8211 16.9684 18.0608C16.874 18.1089 16.7744 18.1485 16.6667 18.1812M3.33343 18.1812C3.33371 17.5067 3.33775 17.1498 3.39746 16.8497C3.66049 15.5274 4.69415 14.4937 6.01645 14.2307C6.33844 14.1666 6.72566 14.1666 7.50008 14.1666H12.5001C13.2745 14.1666 13.6617 14.1666 13.9837 14.2307C15.306 14.4937 16.3397 15.5274 16.6027 16.8497C16.6624 17.1498 16.6665 17.5067 16.6667 18.1812M13.3334 7.91663C13.3334 9.75758 11.841 11.25 10.0001 11.25C8.15913 11.25 6.66675 9.75758 6.66675 7.91663C6.66675 6.07568 8.15913 4.58329 10.0001 4.58329C11.841 4.58329 13.3334 6.07568 13.3334 7.91663Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_5716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/user-square.d4b78df3232335ae371a123e04fe9ddb.svg";
export { ForwardRef as ReactComponent };